import {createReducer, on} from "@ngrx/store";
import {RolesActions} from "../actions";
import type {RoleDto} from "@esa/api";

export const rolesFeatureKey = 'roles';

export interface RolesState {
  roles: RoleDto[];
}

const initialState: RolesState = {
  roles: [],
};

export const rolesReducer = createReducer(
  initialState,
  on(RolesActions.getRolesSuccess, (state, { roles }) => ({ ...state, roles }))
);
